/* eslint-disable react/require-default-props */
/* eslint-disable @typescript-eslint/no-var-requires */
import React, { useEffect } from 'react';
import { useStore } from '../../store';
import VideoTranscript from './videoTranscript';
interface ICourseLandingProps {
  title: string;
  description: string;
  landingImg?: string | null;
  className?: string;
  gif1?: string;
  gif2?: string;
  gif3?: string;
  gif4?: string;
  subItems?: any[] | null;
}
const CourseLanding: React.FunctionComponent<ICourseLandingProps> = ({
  title,
  description,
  landingImg,
  className,
  gif1,
  gif2,
  gif3,
  gif4,
  subItems,
}) => {
  const { language } = useStore();
  useEffect(() => {
    const onPlay = () => {
      if (process.env.REACT_APP_HOST_TYPE === 'dev') {
        return;
      }
      const elem = document?.querySelector('#LandingVideo');
      if (elem?.requestFullscreen) {
        elem.requestFullscreen().catch((error) => {
          console.log(error);
        });
        document
          ?.querySelector('#LandingVideo')
          ?.removeEventListener('play', onPlay);
      }
    };
    document
      ?.querySelector('#LandingVideo')
      ?.removeEventListener('play', onPlay);
    document
      ?.querySelector('#LandingVideo')
      ?.addEventListener('play', onPlay, { passive: true });

    return () =>
      document
        ?.querySelector('#LandingVideo')
        ?.removeEventListener('play', onPlay);
  }, []);

  const [state, setState] = React.useState({
    play: 0,
  });
  const startPlay = (next = -1) => {
    next += 1;
    setState({ play: next });
    if (next <= 4) {
      setTimeout(() => startPlay(next), 1000);
    }
  };
  React.useEffect(() => {
    startPlay();
  }, []);

  return (
    <div className={`course-landing course-landing-container ${className}`}>
      <div className="course-landing-content">
        <div className="course-landing-text">
          <div
            className="title non-border"
            dangerouslySetInnerHTML={{ __html: title }}
          />
          <div
            className="description"
            dangerouslySetInnerHTML={{ __html: description }}
          />
          <div className="gif">
            {gif1 && (
              <>
                <div className="landing-img-panel-sm">
                  <div
                    className={`landing-img-item-sm animation ${
                      state.play >= 1 ? 'fade-in' : ''
                    }`}
                  >
                    <img
                      width="111px"
                      src={require(`../../../../assets/${gif1}`).default}
                      alt=""
                    />
                  </div>
                  <div
                    className={`landing-img-item-sm animation ${
                      state.play >= 2 ? 'fade-in' : ''
                    }`}
                  >
                    <img
                      width="87px"
                      src={require(`../../../../assets/${gif2}`).default}
                      alt=""
                    />
                  </div>
                  <div
                    className={`landing-img-item-sm animation ${
                      state.play >= 3 ? 'fade-in' : ''
                    }`}
                  >
                    <img
                      width="144px"
                      src={require(`../../../../assets/${gif3}`).default}
                      alt=""
                    />
                  </div>
                  <div
                    className={`landing-img-item-sm animation ${
                      state.play >= 4 ? 'fade-in' : ''
                    }`}
                  >
                    <img
                      width="111px"
                      src={require(`../../../../assets/${gif4}`).default}
                      alt=""
                    />
                  </div>
                </div>
              </>
            )}
          </div>
          <div>
            {subItems?.map((itm, index) => {
              switch (itm.component) {
                default:
                  return null;
                case 'video':
                  return (
                    <div key={language + index} className="video-container">
                      <video
                        id="LandingVideo"
                        width="100%"
                        controls
                        autoPlay={process.env.REACT_APP_HOST_TYPE !== 'dev'}
                      >
                        <source src={itm.src} type={itm.type} />
                        Your browser does not support HTML video.
                      </video>
                      <VideoTranscript transcripts={itm.transcripts} />
                    </div>
                  );
              }
            })}
          </div>
        </div>
        <div className="landing-img ">
          {landingImg && (
            <img
              src={require(`../../../../assets/${landingImg}`).default}
              alt=""
            />
          )}
        </div>
      </div>
    </div>
  );
};
CourseLanding.defaultProps = {
  className: '',
  landingImg: '',
  subItems: null,
};

export default CourseLanding;
